module.exports = __webpack_public_path__ + "static/media/title_gameoverf5fd68c29b79c0c1e3cd130eb8839701.webp";